import { useSession } from 'next-auth/react';

type UserRoles = {
  isAdministrator: boolean;
};
/**
 * Checks current session to see if the user is an administrator
 * @returns boolean
 */
export const useAuthorization = (): UserRoles => {
  const { data } = useSession();

  return {
    isAdministrator: data?.isAdmin ?? false
  };
};
